/* global axios */

class AiSummariesAPI {
  constructor() {
    this.baseURL = '/api/v1/accounts';
  }

  generateBulk(accountId, params) {
    return axios.post(`${this.baseURL}/${accountId}/summaries/bulk`, params);
  }

  regenerate(accountId, conversationId, payload = {}) {
    return axios.post(
      `${this.baseURL}/${accountId}/conversations/${conversationId}/summaries`,
      payload
    );
  }
}

export default new AiSummariesAPI();
